@if (device !== undefined) {
  <a class="list-group-item list-group-item-action d-flex lh-1 align-items-start h-100"
     routerLinkActive="active"
     [attr.data-testid]="'mdm-device-cell-' + device?.serialNumber"
     [routerLink]="['/mdm/devices/apple', device.udid]">
    <div>
      {{ device.name }}<br />
      <small class="font-monospace">{{ device.serialNumber }}</small>
    </div>
    <div class="ms-auto ps-3 text-end text-nowrap">
      <fa-icon [icon]="['fab', 'apple']"></fa-icon>
      <br />
      <small>{{ device.lastSeen | date: 'dd-MM-yyyy' }}</small>
    </div>
  </a>
} @else {
  <div class="list-group-item d-flex lh-1 align-items-start h-100">Loading...</div>
}